import produce from 'immer';

import {
  PRODUCT_FETCH_FAILURE,
  PRODUCT_FETCH_REQUEST,
  PRODUCT_FETCH_SUCCESS,
  PRODUCTS_FETCH_FAILURE,
  PRODUCTS_FETCH_REQUEST,
  PRODUCTS_FETCH_SUCCESS,
} from '@actions/product';

const initialState: IProductStore = {
  currentProduct: null,
  products: null,
  isFetching: false,
  error: null,
};

export default (state: IProductStore = initialState, action: any) =>
  produce(state, (draftState: IProductStore) => {
    switch (action.type) {
      case PRODUCTS_FETCH_REQUEST:
        draftState.isFetching = true;
        draftState.products = null;
        draftState.error = null;

        return;

      case PRODUCTS_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.products = action.response;
        draftState.error = null;

        return;

      case PRODUCTS_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.products = null;
        draftState.error = action.error;

        return;

      case PRODUCT_FETCH_REQUEST:
        draftState.isFetching = true;
        draftState.currentProduct = null;
        draftState.error = null;

        return;

      case PRODUCT_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.currentProduct = action.response;
        draftState.error = null;

        return;

      case PRODUCT_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.currentProduct = null;
        draftState.error = action.error;

        return;
    }
  });
